const UserViewLoader = () => {
  return ( 
    <p>Loading User...</p>
  );
}
 
export default UserViewLoader;